<template>
    <div class="imc_memorandum_inside row">
        <mem_preview_left key="menu_preview_left" v-if="is_show"></mem_preview_left>
        <mem_preview_right key="menu_preview_right" v-if="is_show"></mem_preview_right>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import mem_preview_left from "./mem_preview_left.vue";
import mem_preview_right from "./mem_preview_right.vue";

export default {
    name: "mem_preview",
    
    data: function data() {
        return {
            is_show: true
        };
    },
    components: {
        'mem_preview_left': mem_preview_left,
        'mem_preview_right' : mem_preview_right,
    },
    
    created() {
        this.getQuestionData();
    },
    
    methods: {
        async getQuestionData() {
            IMC_CORE.showloading()
            await api.post('memorandum/' + this.selected_mem.tov_id + "/preview", this.selected_mem).then(({data}) => {
                IMC_CORE.hideloading()
                if (data.status === "operation_success") {
                    if (myapp_config.debugState) {
                        console.log("%c|___QUESTION_DATA", "color: #ffc241", data);
                    }
                    
                    this.$store.dispatch('memorandum_create/SET_ACTIVE_MEMORANDUM', data.data);
                    /*
                    let DirInAjusts = data.data.adjsut_users.find(user => user.id === data.message.organization.director_id);
                    this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM', {is_dir_active: (DirInAjusts == undefined)})
                    this.is_show = true;
                    */
                }
            }).catch(err => {
                IMC_CORE.hideloading()
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
    },
    
    computed: {
        selected_mem() {
            return this.create_memorandum.form;
        },
        
        create_memorandum() {
            return this.mem_create('create_memorandum')
        },
        
        ...mapGetters({
            'mem_create': "memorandum_create/getMemCreateField",
        }),
    },
}
</script>

<style scoped>

</style>
